import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const billAccountingStyleId = 'finance-bill-accounting-theme';

export const billAccountingBridgeStyles = {
  'bill-accounting-cell-renderer': {
    '--local-bill-accounting-empty-text': tokens.color.text.tertiary,
  },
  'bill-accounting-field-renderer': {
    '--local-bill-accounting-gap': tokens.spacing.sm,
    '--local-bill-accounting-text': tokens.color.text.primary,
    '--local-bill-accounting-link': tokens.color.text.brandPrimary,
    '--local-bill-accounting-error': tokens.color.text.errorPrimary,
    '--local-bill-accounting-empty-text': tokens.color.text.tertiary,
    '--local-bill-accounting-font-size': tokens.font.size.textSm,
  },
};
